/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'

icon.register({
  'logo': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<g _fill="#FFF" fill-rule="evenodd"><path pid="0" d="M20.584-.743l8.86 15.346-8.86 15.346H2.864V-.743h17.72zm-4.43 7.673h-8.86l-4.43 7.673 4.43 7.673h8.86l4.43-7.673-4.43-7.673z" _fill="url(#linearGradient-1)" transform="scale(1 -1) rotate(90 30.757 0)"/><path pid="1" d="M14.027 10.42l8.86 15.346-8.86 15.346h-.354L9.42 33.524v-.085h.177l4.43-7.673-4.43-7.673h-.124l4.2-7.673h.354z" _fill="url(#linearGradient-2)" transform="matrix(0 -1 -1 0 41.92 41.92)"/></g>'
  }
})
